import { render, staticRenderFns } from "./InvitePage.vue?vue&type=template&id=0e68617a&scoped=true&"
import script from "./InvitePage.vue?vue&type=script&lang=js&"
export * from "./InvitePage.vue?vue&type=script&lang=js&"
import style0 from "./InvitePage.vue?vue&type=style&index=0&id=0e68617a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e68617a",
  null
  
)

export default component.exports